import { DocumentName } from './documents';

export const DEAL_ECONOMICS = 'DEAL_ECONOMICS';
export const REQUESTED_CLOSING_DATE = 'Requested Closing Date';
export const REFERRAL_INFORMATION = 'Off Hud Broker ACH';
export const EXPECTED_CLOSING_DATE = 'Expected Closing Date';
export const TRACKING_NUMBER = 'Tracking Number';
export const DUE_DILIGENCE_PAYMENT = 'Due Diligence Payment';
export const LOAN_FAST_TRACK_PAYMENT = 'Loan Fast Track Payment';
export const TERM_SHEET = 'Term Sheet';
export const BORROWER_SURVEY_QUESTIONNAIRE = 'BORROWER_SURVEY_QUESTIONNAIRE';
export const BORROWER_ENTITY = 'BORROWER_ENTITY';
export const LENDER_FEES = 'LENDER_FEES';
export const TITLE_AGENT = 'TITLE_AGENT';
export const INSURANCE_PROVIDER = 'INSURANCE_PROVIDER';
export const FUNDING_PREFERENCE = 'FUNDING_PREFERENCE';
export const EXPECTED_WIRE_RELEASE_DATE = 'EXPECTED_WIRE_RELEASE_DATE';
export const CLOSING_REVIEW = 'CLOSING_REVIEW';
export const TITLE_DOCUMENTS_REVIEW = 'TITLE_REVIEW';
export const POST_CLOSING_REVIEW = 'POST_CLOSING_REVIEW';
export const INSURANCE_APPROVAL = 'INSURANCE_APPROVAL';
export const INSURANCE_INFORMATION = 'Insurance Information';
export const INSURANCE_INFORMATION_REVIEW = 'Insurance Information Review';
export const LOAN_FUNDING_TEMPLATE = 'LOAN_FUNDING_TEMPLATE';
export const BORROWER_CLOSING_AGENT = 'BORROWER_CLOSING_AGENT';
export const SCOPE_OF_WORK_LINK = 'SCOPE_OF_WORK_LINK';
export const SCOPE_OF_WORK_LINK_V2 = 'SCOPE_OF_WORK_LINK_V2';
export const SCOPE_OF_WORK_FORM = 'SCOPE_OF_WORK_FORM';
export const SCOPE_OF_WORK_FORM_V2 = 'SCOPE_OF_WORK_FORM_V2';
export const NOTE_ALLONGE = 'NOTE_ALLONGE';
export const ASSIGNMENT_AND_CONVEYANCE = 'ASSIGNMENT_AND_CONVEYANCE';
export const RATE_LOCK_EXTENSION = 'Rate Lock Extension';
export const POINT_OF_CONTACT = 'POINT_OF_CONTACT';
export const TITLE_COMPANY_BANK_INFORMATION = 'TITLE_COMPANY_BANK_INFORMATION';
export const RESOLUTION_ITEM_FORM = 'RESOLUTION_ITEM_FORM';
export const MANUAL_TASK = 'MANUAL_TASK';
export const TRACK_RECORD_RESOLUTION_ITEM_FORM = 'TRACK_RECORD_RESOLUTION_ITEM_FORM';
export const RESOLUTION_FORM = 'RESOLUTION_FORM';
export const DOC_REVIEW_FORM = 'DOC_REVIEW_FORM';
export const LIEN_RESOLUTION_DOCUMENT = 'LIEN_RESOLUTION_DOCUMENT';
export const CERTIFICATE_OF_GOOD_STANDING = 'Certificate of Good Standing(+1yr)';
export const ORIGINATOR_STATE_LICENSE = 'Originator State License';
export const COMPANY_STATE_LICENSE = 'Company State License';
export const BORROWER_RESOLUTION = 'Borrower Resolution';
export const DRAW_REPORT = 'Draw Report';
export const BORROWER_BACKGROUND_REVIEW = 'Borrower Background Review';
export const BACKGROUND_REPORT = 'Background Report';
export const BORROWER_CREDIT_REVIEW = 'Borrower Credit Review';
export const TRACK_RECORD_REVIEW = 'Borrower Track Record Review';
export const TRACK_RECORD = 'Track Record';
export const TRACK_RECORD_RESOLUTION = 'Track Record Resolution';
export const PROPERTY_RESOLUTION = 'Property Resolution';
export const CREDIT_REPORT = 'Credit Report';
export const TRIMERGE_CREDIT_REPORT = 'Trimerge Credit Report';
export const CLOSING_CONDITION = 'Closing Condition - ';
export const APPRAISAL_ORDER_DETAILS = 'Appraisal Order Details';
export const APPRAISAL_DETAILS = 'Appraisal Details';
export const ACH_FORM = 'ACH Consent Form';
export const APPRAISAL_REPORT = 'Appraisal Report';
export const APPRAISAL_REPORT_AS_IS_RENT =
  'Appraisal Report (As-Is w/ Rent Schedule)';
export const APPRAISAL_REPORT_AS_IS = 'Appraisal Report (As is)';
export const APPRAISAL_REPORT_ARV = 'Appraisal Report (ARV)';
export const APPRAISAL_RESOLUTIONS = 'Appraisal Resolutions';
export const BORROWER_SETUP = 'Borrower Setup';
export const CREDIT_AUTHORIZATION = 'Credit Authorization';
export const BACKGROUND_AUTHORIZATION = 'Background Authorization';
export const BORROWER_IDENTITY_VERIFICATION = 'Borrower Identity Verification';
export const APPRAISAL_REVIEW_REPORT = 'Appraisal Review Report';
export const SCOPE_OF_WORK = 'Scope of Work';
export const EIN_LETTER = 'EIN Letter';
export const BANK_STATEMENT_PREFIX = 'Bank Statement #';
export const BANK_STATEMENT_MONTH_PREFIX = 'Bank Statement -';
export const BANK_STATEMENT_TASK_CODE = 'Bank Statement';
export const LEASE_INFORMATION_UNIT_PREFIX = 'Lease Information Unit';
export const LEASE_AGREEMENT_PREFIX = 'Lease Agreement';
export const TAX_ESCROW = 'Tax Escrow';
export const POST_DISASTER_INSPECTION = 'Post Disaster Inspection';
export const PERSONAL_IDENTIFICATION = 'Personal Identification';
export const WIMBA_NAME = 'Wimba Title Insurance Agency, LLC';
export const CONSTRUCTION_FEASIBILITY_REVIEW = 'Construction Feasibility Review';
export const INTERNAL_VALUATION_REPORT = 'Valuation Team Report';
export const PERMITS = 'Architect Letter Or Permits';
export const DRAW_REQUEST_FORM = "Draw Request Form";
export const DRAW_INFORMATION = "Draw Information";
export const WIRE_AUTHORIZATION = "Wire authorization";
export const INSPECTION_INVOICE_DETAILS = "Inspection Invoice Details";
export const DRAW_REVIEW_REPORT = "Draw Review Report";
export const REVISED_SOW_FORM = "Revised SOW Form";
export const TAKE_PROPERTY_PHOTOS = 'Take Property Photos';
export const SITE_INSPECTION_CM_REPORT = 'Site Inspection & CM Report';
export const CONFIRM_LOAN_TERMS = 'Confirm Loan Terms';
export const TAKE_INTERNAL_VALUATION_PHOTOS = 'RealVal Property Photos';
export const INTERNAL_VALUATION = "RealVal Fee";
export const SERVICER_FEES = "Servicer Fees";
export const PAYOFF_REQUEST_DETAILS = "Payoff Request Details";
export const SERVICER_PROVIDED_DATA = "Servicer Provided Data";
export const INTEREST_ALLOCATION = "Interest Allocation";
export const FORECLOSURE_INTEREST_ALLOCATION = "Foreclosure Interest Allocation";
export const PAYOFF_CORRECTION = "Payoff Correction";
export const PAYABLE_ATTESTATION = "Payable Attestation";
export const DQ_TAXES_ATTESTATION = "DQ Taxes Attestation";
export const PAYOFF_CALCULATOR = "Payoff Calculator";
export const CONFIRM_FIRST_APPRAISAL_VALUE = "Confirm First Appraisal Value";
export const PAYOFF_RECONCILIATION_REVIEW = "Payoff Reconciliation Review";
export const UNDERWRITE_THE_LOAN = 'Underwrite The Loan';
export const ACCEPT_LOAN_TERMS = "Accept Loan Terms";
export const VALUATION_DETAILS = 'Valuation Details';
export const INSURANCE_DOCUMENT = "Insurance Document";
export const EXTENSION_DETAILS = "Extension Details";
export const EXTENSION_AGREEMENT = "Extension Agreement";
export const SETTLEMENT_DETAILS = "Settlement Details";
export const TITLE_AGENCY = "Title Agency";
export const REALIZED_LOSS = "Realized Principal And Interest Loss";
export const DELINQUENCY_STATUS = "Delinquency Status And Comments";
export const POST_MORTEM = "Post-Mortem";
export const PROPERTY_APPRAISALS = "Property Appraisals";
export const PROPERTY_VALUATIONS = "Appraisal Valuation";
export const FORECLOSURE_ATTORNEY = "Foreclosure Attorney";
export const FORECLOSURE_STAGES = "Foreclosure stages";
export const VALUATION_PAYMENT = 'Valuation Payment';
export const PRESCREEN = 'Prescreen';
export const CLIENT_VALUATION_DISPUTE = 'Client Valuation Dispute';
export const INTERNAL_VALUATION_ROV_FOR_APPRAISAL = 'Internal Valuation ROV for Appraisal';
export const INSURANCE_DETAILS = 'Insurance Details';
export const TITLE_COMMITMENT = 'Title Commitment';
export const HUD = 'HUD';
export const PROOF_OF_RECEIPT = 'Proof of Receipt of Rental Income for Most Recent 3 Months';
export const TAX_CERTIFICATE = 'Tax Certificate';
export const CLOSING_INSTRUCTION_LETTER = 'Closing Instruction Letter';
export const BORROWER_LIQUIDITY = 'Borrower Liquidity';
export const LEASE_AGREEMENT = 'Lease Agreement';
export const UW_HUD = 'HUD or Other Documentation of Property Ownership (Refi Only)';
export const HUD_DOC = 'HUD (Refi Only)';
export const HOA = 'HomeOwners Association (HOA) Fee Document';
export const PURCHASE_CONTRACT = 'Purchase Contract with all Addendums';
export const WHOLESALER_CONTRACT = 'Wholesaler Contract or Assignment of Bid';
export const APPRAISAL_REASSIGNMENT_LETTER = 'Appraisal Reassignment Letter';
export const CLOSING_PROTECTION_LETTER = 'Closing Protection Letter (CPL)';
export const GC_LICENSE = 'GC License';
export const BROKER_LICENSE = 'Broker License';
export const FINAL_TITLE_POLICY = 'Final Title Policy';
export const RECORDED_MORTGAGE = 'Recorded Mortgage';
export const RECORDED_ALR = 'Recorded ALR';
export const CERTIFICATE_OF_FORMATION = 'Certificate of Formation (LLC)';
export const OPERATING_AGREEMENT = 'Operating Agreement (LLC)';
export const BYLAWS = 'Bylaws (Corp)';
export const BORROWING_CORP_STOCK_CERTIFICATE = 'Borrowing Corp Stock Certificate';
export const FILING_RECEIPT = 'Filing Receipt';
export const ARTICLES_OF_INCORPORATION = 'Articles of Incorporation (Corp)';
export const CERTIFICATE_OF_GOOD_STANDING_BASE = 'Certificate of Good Standing';
export const CERTIFICATE_OF_EXISTENCE = 'Certificate of Existence';
export const BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING = 'Borrower LLC Certificate of Good Standing';
export const FOREIGN_ENTITY_REGISTRATION = 'Foreign Entity Registration';
export const RECORDED_UCC1_STATE = 'Recorded UCC1- State';
export const RECORDED_UCC1_COUNTY = 'Recorded UCC1- County';
export const SELLER_ENTITY_DOCUMENTS = 'Seller Entity Documents';

// consolidated entity tasks: one task replaces the per-document ones it lists
export const CERT_OF_FORMATION_OR_INC = 'Certificate of Formation or Certificate of Incorporation';
export const CERT_OF_GOOD_STANDING_OR_EXISTENCE = 'Certificate of Good Standing or Certificate of Existence';
export const OPERATING_AGREEMENT_BYLAWS_STOCK = 'Operating Agreement or Bylaws or Stock Certificate';
export const RECORDED_CEMA = 'Recorded CEMA';
export const RECORDED_BUILDING_MORTGAGE = 'Recorded Building Mortgage';

export const DOCUMENT_FORMS = {
  [DocumentName.DEAL_ECONOMICS]: DEAL_ECONOMICS,
  [DocumentName.REQUESTED_CLOSING_DATE]: REQUESTED_CLOSING_DATE,
  [DocumentName.EXPECTED_CLOSING_DATE]: EXPECTED_CLOSING_DATE,
  [DocumentName.TRACKING_NUMBER]: TRACKING_NUMBER,
  [DocumentName.DUE_DILIGENCE_PAYMENT]: DUE_DILIGENCE_PAYMENT,
  [DocumentName.APPRAISAL_ORDER_DETAILS]: APPRAISAL_ORDER_DETAILS,
  [DocumentName.APPRAISAL_DETAILS]: APPRAISAL_DETAILS,
  [DocumentName.LOAN_FAST_TRACK_PAYMENT]: LOAN_FAST_TRACK_PAYMENT,
  [DocumentName.TERM_SHEET]: TERM_SHEET,
  [DocumentName.BORROWER_SURVEY_QUESTIONNAIRE]: BORROWER_SURVEY_QUESTIONNAIRE,
  [DocumentName.EXPECTED_WIRE_RELEASE_DATE]: EXPECTED_WIRE_RELEASE_DATE,
  [DocumentName.BORROWER_ENTITY]: BORROWER_ENTITY,
  [DocumentName.CERTIFICATE_OF_GOOD_STANDING]: CERTIFICATE_OF_GOOD_STANDING,
  [DocumentName.LENDER_FEES]: LENDER_FEES,
  [DocumentName.TITLE_AGENT]: TITLE_AGENT,
  [DocumentName.INSURANCE_PROVIDER]: INSURANCE_PROVIDER,
  [DocumentName.INSURANCE_APPROVAL]: INSURANCE_APPROVAL,
  [DocumentName.INSURANCE_INFORMATION]: INSURANCE_INFORMATION,
  [DocumentName.INSURANCE_INFORMATION_REVIEW]: INSURANCE_INFORMATION_REVIEW,
  [DocumentName.EXTENSION_DETAILS]: EXTENSION_DETAILS,
  [DocumentName.EXTENSION_AGREEMENT]: EXTENSION_AGREEMENT,
  [DocumentName.LOAN_FUNDING_TEMPLATE]: LOAN_FUNDING_TEMPLATE,
  [DocumentName.BORROWER_CLOSING_AGENT]: BORROWER_CLOSING_AGENT,
  [DocumentName.SCOPE_OF_WORK]: [
    SCOPE_OF_WORK_LINK,
    SCOPE_OF_WORK_LINK_V2,
    SCOPE_OF_WORK_FORM,
    SCOPE_OF_WORK_FORM_V2,
  ],
  [DocumentName.DIGITAL_SCOPE_OF_WORK]: [
    SCOPE_OF_WORK_LINK,
    SCOPE_OF_WORK_FORM,
  ],
  [DocumentName.SETTLEMENT_DETAILS]: SETTLEMENT_DETAILS,
  [DocumentName.TITLE_AGENCY]: TITLE_AGENCY,
  [DocumentName.REALIZED_LOSS]: REALIZED_LOSS,
  [DocumentName.DELINQUENCY_STATUS]: DELINQUENCY_STATUS,
  [DocumentName.POST_MORTEM]: POST_MORTEM,
  [DocumentName.PROPERTY_APPRAISALS]: PROPERTY_APPRAISALS,
  [DocumentName.FORECLOSURE_STAGES]: FORECLOSURE_STAGES,
  [DocumentName.PROPERTY_VALUATIONS]: PROPERTY_VALUATIONS,
  [DocumentName.FORECLOSURE_ATTORNEY]: FORECLOSURE_ATTORNEY,
  [DocumentName.NOTE_ALLONGE]: NOTE_ALLONGE,
  [DocumentName.ASSIGNMENT_AND_CONVEYANCE]: ASSIGNMENT_AND_CONVEYANCE,
  [DocumentName.FUNDING_PREFERENCE]: FUNDING_PREFERENCE,
  [DocumentName.RATE_LOCK_EXTENSION]: RATE_LOCK_EXTENSION,
  [DocumentName.POINT_OF_CONTACT]: POINT_OF_CONTACT,
  [DocumentName.TITLE_COMPANY_BANK_INFORMATION]: TITLE_COMPANY_BANK_INFORMATION,
  [DocumentName.DRAW_REPORT]: DRAW_REPORT,
  [DocumentName.BORROWER_BACKGROUND_REVIEW]: BORROWER_BACKGROUND_REVIEW,
  [DocumentName.BACKGROUND_REPORT]: BACKGROUND_REPORT,
  [DocumentName.BORROWER_CREDIT_REVIEW]: BORROWER_CREDIT_REVIEW,
  [DocumentName.TRIMERGE_CREDIT_REPORT]: TRIMERGE_CREDIT_REPORT,
  [DocumentName.TRACK_RECORD_REVIEW]: TRACK_RECORD_REVIEW,
  [DocumentName.TRACK_RECORD]: TRACK_RECORD,
  [DocumentName.ACH_FORM]: ACH_FORM,
  [DocumentName.APPRAISAL_REPORT_ARV]: APPRAISAL_REPORT_ARV,
  [DocumentName.APPRAISAL_REPORT_AS_IS_RENT]: APPRAISAL_REPORT_AS_IS_RENT,
  [DocumentName.APPRAISAL_REPORT_AS_IS]: APPRAISAL_REPORT_AS_IS,
  [DocumentName.APPRAISAL_REPORT]: APPRAISAL_REPORT,
  [DocumentName.APPRAISAL_RESOLUTIONS]: APPRAISAL_RESOLUTIONS,
  [DocumentName.BORROWER_SETUP]: BORROWER_SETUP,
  [DocumentName.CREDIT_AUTHORIZATION]: CREDIT_AUTHORIZATION,
  [DocumentName.BORROWER_IDENTITY_VERIFICATION]: BORROWER_IDENTITY_VERIFICATION,
  [DocumentName.APPRAISAL_REVIEW_REPORT]: APPRAISAL_REVIEW_REPORT,
  [DocumentName.REFERRAL_INFORMATION]: REFERRAL_INFORMATION,
  [DocumentName.PERSONAL_IDENTIFICATION]: PERSONAL_IDENTIFICATION,
  [DocumentName.CONSTRUCTION_FEASIBILITY_REVIEW]: CONSTRUCTION_FEASIBILITY_REVIEW,
  [DocumentName.INTERNAL_VALUATION_REPORT]: INTERNAL_VALUATION_REPORT,
  [DocumentName.PERMITS]: PERMITS,
  [DocumentName.CLOSING_REVIEW]: CLOSING_REVIEW,
  [DocumentName.TITLE_DOCUMENTS_REVIEW]: TITLE_DOCUMENTS_REVIEW,
  [DocumentName.POST_CLOSING_REVIEW]: POST_CLOSING_REVIEW,
  [DocumentName.DRAW_REQUEST_FORM]: DRAW_REQUEST_FORM,
  [DocumentName.DRAW_INFORMATION]: DRAW_INFORMATION,
  [DocumentName.WIRE_AUTHORIZATION]: WIRE_AUTHORIZATION,
  [DocumentName.INSPECTION_INVOICE_DETAILS]: INSPECTION_INVOICE_DETAILS,
  [DocumentName.REVISED_SOW_FORM]: REVISED_SOW_FORM,
  [DocumentName.INTERNAL_VALUATION]: INTERNAL_VALUATION,
  [DocumentName.TAKE_PROPERTY_PHOTOS]: TAKE_PROPERTY_PHOTOS,
  [DocumentName.SITE_INSPECTION_CM_REPORT]: SITE_INSPECTION_CM_REPORT,
  [DocumentName.CONFIRM_LOAN_TERMS]: CONFIRM_LOAN_TERMS,
  [DocumentName.SERVICER_FEES]: SERVICER_FEES,
  [DocumentName.PAYOFF_REQUEST_DETAILS]: PAYOFF_REQUEST_DETAILS,
  [DocumentName.SERVICER_PROVIDED_DATA]: SERVICER_PROVIDED_DATA,
  [DocumentName.INTEREST_ALLOCATION]: INTEREST_ALLOCATION,
  [DocumentName.FORECLOSURE_INTEREST_ALLOCATION]: FORECLOSURE_INTEREST_ALLOCATION,
  [DocumentName.PAYOFF_CORRECTION]: PAYOFF_CORRECTION,
  [DocumentName.PAYABLE_ATTESTATION]: PAYABLE_ATTESTATION,
  [DocumentName.DQ_TAXES_ATTESTATION]: DQ_TAXES_ATTESTATION,
  [DocumentName.PAYOFF_CALCULATOR]: PAYOFF_CALCULATOR,
  [DocumentName.TAKE_INTERNAL_VALUATION_PHOTOS]: TAKE_INTERNAL_VALUATION_PHOTOS,
  [DocumentName.CONFIRM_FIRST_APPRAISAL_VALUE]: CONFIRM_FIRST_APPRAISAL_VALUE,
  [DocumentName.PAYOFF_RECONCILIATION_REVIEW]: PAYOFF_RECONCILIATION_REVIEW,
  [DocumentName.UNDERWRITE_THE_LOAN]: UNDERWRITE_THE_LOAN,
  [DocumentName.ACCEPT_LOAN_TERMS]: ACCEPT_LOAN_TERMS,
  [DocumentName.VALUATION_DETAILS]: VALUATION_DETAILS,
  [DocumentName.INSURANCE_DOCUMENT]: INSURANCE_DOCUMENT,
  [DocumentName.VALUATION_PAYMENT]: VALUATION_PAYMENT,
  [DocumentName.TRACK_RECORD_RESOLUTION]: TRACK_RECORD_RESOLUTION,
  [DocumentName.PROPERTY_RESOLUTION]: PROPERTY_RESOLUTION,
  [DocumentName.PRESCREEN]: PRESCREEN,
  [DocumentName.CLIENT_VALUATION_DISPUTE]: CLIENT_VALUATION_DISPUTE,
  [DocumentName.INTERNAL_VALUATION_ROV_FOR_APPRAISAL]: INTERNAL_VALUATION_ROV_FOR_APPRAISAL,
  [DocumentName.INSURANCE_DETAILS]: INSURANCE_DETAILS,
  [DocumentName.TITLE_COMMITMENT]: TITLE_COMMITMENT,
  [DocumentName.BORROWER_LIQUIDITY]: BORROWER_LIQUIDITY,
  [DocumentName.LEASE_AGREEMENT]: LEASE_AGREEMENT,
  [DocumentName.APPRAISAL_REASSIGNMENT_LETTER]: APPRAISAL_REASSIGNMENT_LETTER,
  [DocumentName.ORIGINATOR_STATE_LICENSE]: ORIGINATOR_STATE_LICENSE,
  [DocumentName.COMPANY_STATE_LICENSE]: COMPANY_STATE_LICENSE,
  [DocumentName.PURCHASE_CONTRACT]: PURCHASE_CONTRACT,
};

export const AUTOMATED_DOC_REVIEW_FORMS = {
  [DocumentName.HUD]: HUD,
  [DocumentName.PROOF_OF_RECEIPT]: PROOF_OF_RECEIPT,
  [DocumentName.TAX_CERTIFICATE]: TAX_CERTIFICATE,
  [DocumentName.UW_HUD]: UW_HUD,
  [DocumentName.HUD_DOC]: UW_HUD,
  [DocumentName.HOA]: HOA,
  [DocumentName.WHOLESALER_CONTRACT]: WHOLESALER_CONTRACT,
  [DocumentName.CLOSING_INSTRUCTION_LETTER]: CLOSING_INSTRUCTION_LETTER,
  [DocumentName.CLOSING_PROTECTION_LETTER]: CLOSING_PROTECTION_LETTER,
  [DocumentName.GC_LICENSE]: GC_LICENSE,
  [DocumentName.BROKER_LICENSE]: BROKER_LICENSE,
  [DocumentName.FINAL_TITLE_POLICY]: FINAL_TITLE_POLICY,
  [DocumentName.RECORDED_MORTGAGE]: RECORDED_MORTGAGE,
  [DocumentName.RECORDED_ALR]: RECORDED_ALR,
  [DocumentName.CERTIFICATE_OF_FORMATION]: CERTIFICATE_OF_FORMATION,
  [DocumentName.OPERATING_AGREEMENT]: OPERATING_AGREEMENT,
  [DocumentName.BYLAWS]: BYLAWS,
  [DocumentName.BORROWING_CORP_STOCK_CERTIFICATE]: BORROWING_CORP_STOCK_CERTIFICATE,
  [DocumentName.FILING_RECEIPT]: FILING_RECEIPT,
  [DocumentName.ARTICLES_OF_INCORPORATION]: ARTICLES_OF_INCORPORATION,
  [DocumentName.CERTIFICATE_OF_GOOD_STANDING]: CERTIFICATE_OF_GOOD_STANDING,
  [DocumentName.CERTIFICATE_OF_GOOD_STANDING_BASE]: CERTIFICATE_OF_GOOD_STANDING_BASE,
  [DocumentName.CERTIFICATE_OF_EXISTENCE]: CERTIFICATE_OF_EXISTENCE,
  [CERT_OF_FORMATION_OR_INC]: CERT_OF_FORMATION_OR_INC,
  [CERT_OF_GOOD_STANDING_OR_EXISTENCE]: CERT_OF_GOOD_STANDING_OR_EXISTENCE,
  [OPERATING_AGREEMENT_BYLAWS_STOCK]: OPERATING_AGREEMENT_BYLAWS_STOCK,
  [DocumentName.BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING]: BORROWER_LLC_CERTIFICATE_OF_GOOD_STANDING,
  [DocumentName.FOREIGN_ENTITY_REGISTRATION]: FOREIGN_ENTITY_REGISTRATION,
  [DocumentName.RECORDED_UCC1_STATE]: RECORDED_UCC1_STATE,
  [DocumentName.RECORDED_UCC1_COUNTY]: RECORDED_UCC1_COUNTY,
  [DocumentName.SELLER_ENTITY_DOCUMENTS]: SELLER_ENTITY_DOCUMENTS,
  [DocumentName.EIN_LETTER]: EIN_LETTER,
  [DocumentName.RECORDED_CEMA]: RECORDED_CEMA,
  [DocumentName.RECORDED_BUILDING_MORTGAGE]: RECORDED_BUILDING_MORTGAGE,
}
